import styled from 'styled-components';
import { UIElements } from '@ansvar-sakerhet/ui';

const LoadingContainer = styled.div`
  padding: 16px;
`;

const ErrorContainer = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const WorkRegisterTableSubRowContainer = styled.div`
  min-height: 200px;
  width: 100%;
  display: flex;
`;

const Divider = styled.div`
  width: 20px;
  min-height: 200px;
  height: 100%;
`;

const PersonnelPanel = styled.div`
  position: relative;
  width: 100%;
  margin-bottom: auto;
`;

const PersonnelContainer = styled.div`
  display: grid;
  padding: 16px;
  padding-top: 48px;
  grid-template-columns: 1fr 4fr;
  gap: 20px;
  width: 100%;
`;

const QuestionnaireContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  padding-top: 48px;
  width: 100%;

  &::after {
    content: '';
    position: absolute;
    left: -16px;
    top: 16px;
    bottom: 16px;
    width: 1px;
    background-color: ${({ theme }) => theme.colors.gray};
  }
`;

const LeftActions = styled.div`
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 1;
`;

const RightActions = styled.div`
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 1;
`;

const ImageContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  padding: 8px 0;
  width: 100%;
  max-width: 328px;
`;

const Image = styled.img`
  width: 150px;
  height: auto;
  overflow: hidden;
  object-fit: scale;
  border-radius: 2px;
`;

export const S = {
  ...UIElements,
  LoadingContainer,
  ErrorContainer,
  WorkRegisterTableSubRowContainer,
  Divider,
  PersonnelPanel,
  PersonnelContainer,
  QuestionnaireContainer,
  LeftActions,
  RightActions,
  ImageContainer,
  Image,
};
